import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanDisbursementChecklistPageUI from './LoanDisbursementChecklistPageUI.js'

class LoanDisbursementChecklistPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null
    }
  }

  render() {
    return (
      <LoanDisbursementChecklistPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      loan: response.loan
    })
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context

    if (!loan) return

    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))

    if (noBusy === 'noBusy') {
      this.getLoan(context)
    } else {
      this.setState({
        loan: null,
        errorList: null
      })
      this.getLoan(context)
    }
  }
}

export default withRouter(LoanDisbursementChecklistPageSF)